import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizationCaseLimitEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.boundaryType = null;
		/** @type {number} */
		this.boundary = null;
		/** @type {number} */
		this.value = null;
		/** @type {number} */
		this.factor = null;
		/** @type {number} */
		this.bias = null;
	}

	/**
	 * @typedef {Object} _OptimizationCaseLimitEditDtoProps
	 * @property {string} type
	 * @property {string} boundaryType
	 * @property {number} boundary
	 * @property {number} value
	 * @property {number} factor
	 * @property {number} bias
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationCaseLimitEditDtoProps} OptimizationCaseLimitEditDtoProps
	 */

	/**
	 * @param {OptimizationCaseLimitEditDtoProps} props
	 * @returns {OptimizationCaseLimitEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.boundaryType = props.boundaryType;
		this.boundary = props.boundary;
		this.value = props.value;
		this.factor = props.factor;
		this.bias = props.bias;
		return this;
	}
}

export default OptimizationCaseLimitEditDto;